import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { selectemployeeData } from "../store/home/home.selectors";
import { updateShowAccountOverlayFlag } from "../store/home/home.actions";

const mapStateToProps = (state) => {
  return {
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      updateShowAccountOverlayFlag,
    },
    dispatch
  ),
});

class AppFooterWeb extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer-section">
          <div className="footer-section-one">
            <Link to="/" className="footer-drexelicon">
              <img
                src={require("../assets/images/drexel icon.png")}
                alt="drexel-icon"
              />
            </Link>
            <Link to="/" className="footer-electrified">
              <img
                src={require("../assets/images/electrified.png")}
                alt="electrified"
              />
            </Link>
          </div>
          <div className="footer-section-two">
            <p
              onClick={() => {
                if (this.props.pathName === "/") {
                  window.scrollTo(0, 0);
                } else {
                  this.props.history.push("/");
                }
              }}
            >
              Explore All
            </p>
            <p
              onClick={() => {
                if (this.props.pathName === "/stories") {
                  window.scrollTo(0, 0);
                } else {
                  this.props.history.push("/stories");
                }
              }}
            >
              Stories
            </p>
            <p
              onClick={() => {
                if (this.props.pathName === "/collections") {
                  window.scrollTo(0, 0);
                } else {
                  this.props.history.push("/collections");
                }
              }}
            >
              Collections
            </p>
            <p
              onClick={() => {
                if (this.props.pathName === "/about") {
                  window.scrollTo(0, 0);
                } else {
                  this.props.history.push("/about");
                }
              }}
            >
              About Exhibit
            </p>
          </div>
          {this.props.employeeData?.employeeId != null && (
            <div className="footer-section-two">
              <p
                onClick={() => {
                  if (this.props.pathName === "/favorites") {
                    window.scrollTo(0, 0);
                  } else {
                    this.props.history.push("/favorites");
                  }
                }}
              >
                My Favorites
              </p>
              <p>
                <span onClick={() => this.props.updateShowAccountOverlayFlag()}>
                  Account
                </span>
              </p>
            </div>
          )}
        </div>
        <div className="footer-content">
          <img
            src={require("../assets/images/ciright.png")}
            className="ciright-img"
            alt="ciright"
          />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppFooterWeb);
